import { useEffect, useRef } from 'react';
import { useConfig } from './useConfig';

export const useDocumentTitle = (
  title: string | undefined,
  retainOnUnmount = false
) => {
  const defaultTitle = useRef(document.title);

  const firebaseConfig = useConfig();

  useEffect(() => {
    document.title = `${title ? `${title} - ` : ''} ${
      `${firebaseConfig?.displayName} | ` || ''
    }Fitnessly`;
  }, [title, firebaseConfig]);

  useEffect(
    () => () => {
      if (!retainOnUnmount) {
        document.title = defaultTitle.current;
      }
    },
    []
  );
};
